export default {"src":"/_next/static/media/yesterday.85d7911b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};